import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component }  from 'react';
import {Tab, Row, Col} from "react-bootstrap";
import Moment from "moment";
import Select from "react-select";
import NumericInput from 'react-numeric-input';
import {slugify} from "./UpdateRaceModal";
import { apiFetch, API, getMarket } from "../../services/api";


export default class AddEventModal extends Component {
    constructor(props) {
        console.log(props)
        super(props);
        this.state ={
            selectedImage: this.props.selectedEvent.image,
            adSets: [],
            adSetsError: null,
            selectedAdSets: (this.props.selectedEvent.adSetIDs || []).map(id => ({ value: id, label: id })),
        };
    }

    componentDidMount() {
        apiFetch(API.back + '/physical-event-adsets', { method: 'GET' })
            .then((res) => {
                if (!res.ok) {
                    this.setState({ adSets: [], adSetsError: "Ensembles de pubs indisponibles (" + res.status + ")" });
                    return null;
                }
                return res.json();
            })
            .then((adSets) => {
                if (adSets === null) {
                    return;
                }
                const list = Array.isArray(adSets) ? adSets : [];
                this.setState({
                    adSets: list,
                    // Les ensembles arrivent après le montage : on recalcule les options sélectionnées
                    // (labels complets) une fois la liste chargée, plutôt que via defaultValue.
                    selectedAdSets: (this.props.selectedEvent.adSetIDs || []).map(id => {
                        const a = list.find(x => x.adSetID === id);
                        return a ? this.adSetOption(a) : { value: id, label: id };
                    }),
                });
            })
            .catch((err) => { console.log(err); this.setState({ adSetsError: "Ensembles de pubs indisponibles" }); });
    }

    adSetOption = (a) => ({
        value: a.adSetID,
        label: a.adSetName + " — " + a.campaignName + " — " + (Number(a.spend) || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })
            + (a.attachedTo && a.attachedTo !== this.props.selectedEvent.name ? " (déjà rattaché à " + a.attachedTo + ")" : ""),
    });

    handleClose = () => {
        this.props.selectedEvent.isAutomaticallyValidated = this.state.isAutomaticallyValidated
        this.props.selectedEvent.language = getMarket()

        apiFetch(API.back + '/physical-event', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.props.selectedEvent)
        })
            .then(() => (
                    sleep(2000),
                        this.props.closeModal,
                        window.location.reload(false)
            )
                )
            .catch( err =>
                console.log(err)
            );
    }

    uploadLogo = async (e) => {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            apiFetch(API.back + '/upload-file', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "physical-events/"+fileName
                })
            }).then((res) =>
                res.json().then( result =>{
                        sleep(2000)
                        this.props.selectedEvent.image = result.message
                        this.setState({selectedImage: result.message})
                    }
                )
            )
                .catch( err =>
                    console.log(err)
                );
        }
    }

    render(){

        return(
            <Modal
                show={this.props.isOpen}
                onHide={this.props.closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter un évènement phyisque</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Row>
                            <Col>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Form.Group >
                                            <Form.Label>Nom : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => (this.props.selectedEvent.name = e.target.value)} defaultValue={this.props.selectedEvent.name} placeholder="Ex : Testing Magic Speed 3"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Lieu : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => (this.props.selectedEvent.town = e.target.value, this.props.selectedEvent.slug = slugify(this.props.selectedEvent.name + "-"+e.target.value))} defaultValue={this.props.selectedEvent.town} placeholder="Ex : Rennes"/>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Date de l'évènement : </Form.Label>
                                            <Form.Control key="beginDate" type="datetime-local" name="begin" placeholder="Début"
                                                          defaultValue={Moment(this.props.selectedEvent.date).format('YYYY-MM-DDTHH:mm').toString()}
                                                          onChange={(e) => this.props.selectedEvent.date = new Date(e.target.value).toISOString()}
                                            />
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Image de couverture : </Form.Label>
                                            <Form.File
                                                id="custom-file-translate-html"
                                                label="Ajouter un image"
                                                data-browse="Ajouter"
                                                onChange= {(e) => this.uploadLogo(e)}
                                                custom
                                            />
                                            {this.state.selectedImage ? <img alt="Logo..." className="imgToDisplay" src={this.state.selectedImage}/>
                                            :
                                                null
                                            }
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Description courte de la vignette</Form.Label>
                                            <Form.Control as="textarea" rows={4} onChange={(e) => {this.props.selectedEvent.description = e.target.value; this.setState({numberOfCharMetaDescription: e.target.value})}} defaultValue={this.props.selectedEvent.description ? this.props.selectedEvent.description : this.props.selectedEvent.description} placeholder="Envie de tester la magic speed 3?"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Description longue de la page de l'évènement</Form.Label>
                                            <Form.Control as="textarea" rows={4} onChange={(e) => {this.props.selectedEvent.longDescription = e.target.value; this.setState({numberOfCharMetaDescription: e.target.value})}} defaultValue={this.props.selectedEvent.longDescription ? this.props.selectedEvent.longDescription : this.props.selectedEvent.longDescription} placeholder="Venez tester la nouvelle ASICS Magic Speed 3 à Rennes, sur le parcours du Hill, le 23 octobre 2023 à 18h30. Felix Bour sera aussi présent pour répondre à vos questions. blablabla"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Validation automatique de la participation ? </Form.Label>
                                            <Form.Check aria-label="availableSoon"
                                                        defaultChecked={this.props.selectedEvent.isAutomaticallyValidated}
                                                        onChange={(e) => this.setState({isAutomaticallyValidated: e.target.checked})} />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Coût hors Ads (€) — logistique, coachs, goodies</Form.Label>
                                            <Form.Control type="number" min="0" step="1" defaultValue={this.props.selectedEvent.cost || 0}
                                                          onChange={(e) => this.props.selectedEvent.cost = Number(e.target.value) || 0}/>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Ensembles de pubs Meta détectés automatiquement (pubs pointant vers cette page évènement)</Form.Label>
                                            {this.state.adSets.filter(a => a.eventSlug && a.eventSlug === this.props.selectedEvent.slug).length === 0
                                                ? <div className="text-muted small">Aucun — vérifier que les pubs de l'ensemble pointent vers /physical-event/{this.props.selectedEvent.slug}</div>
                                                : this.state.adSets.filter(a => a.eventSlug === this.props.selectedEvent.slug).map(a => (
                                                    <div key={a.adSetID} className="small">✔ {a.adSetName} — {a.campaignName} — {(Number(a.spend) || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}</div>
                                                ))}
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Ensembles de pubs à ajouter manuellement (campagnes EVENT, 120 derniers jours)</Form.Label>
                                            {this.state.adSetsError ? <div className="text-danger small">{this.state.adSetsError}</div> : null}
                                            <Select isMulti placeholder="Choisir un ou plusieurs ensembles…"
                                                    options={[...this.state.adSets].filter(a => a.eventSlug !== this.props.selectedEvent.slug).sort((a, b) => (a.attachedTo ? 1 : 0) - (b.attachedTo ? 1 : 0)).map(this.adSetOption)}
                                                    value={this.state.selectedAdSets}
                                                    onChange={(selected) => {
                                                        this.props.selectedEvent.adSetIDs = (selected || []).map(o => o.value);
                                                        this.setState({ selectedAdSets: selected || [] });
                                                    }}/>
                                            <div className="text-muted small">Pour les ensembles dont les pubs ne pointent pas vers la page de l'évènement. Leur dépense s'ajoute à celle des ensembles détectés (modale ROI). Les ensembles non rattachés sont listés en premier.</div>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Évènement paddock (créneau + marque demandés à l'inscription) ? </Form.Label>
                                            <Form.Check aria-label="isPaddock"
                                                        defaultChecked={this.props.selectedEvent.isPaddock}
                                                        onChange={(e) => this.props.selectedEvent.isPaddock = e.target.checked} />
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Évènement VMA (créneau Midi/Soir demandé à l'inscription) ? </Form.Label>
                                            <Form.Check aria-label="isVMA"
                                                        defaultChecked={this.props.selectedEvent.isVMA}
                                                        onChange={(e) => this.props.selectedEvent.isVMA = e.target.checked} />
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Lieux par session (VMA) : </Form.Label>
                                            <Form.Control type="text" className="mb-1"
                                                          defaultValue={(this.props.selectedEvent.sessionLocations || {})["Midi"] || ""}
                                                          onChange={(e) => (this.props.selectedEvent.sessionLocations = { ...(this.props.selectedEvent.sessionLocations || {}), Midi: e.target.value })}
                                                          placeholder="Session Midi — ex : Stade de Bréquigny, 12 bd Albert 1er, Rennes"/>
                                            <Form.Control type="text"
                                                          defaultValue={(this.props.selectedEvent.sessionLocations || {})["Soir"] || ""}
                                                          onChange={(e) => (this.props.selectedEvent.sessionLocations = { ...(this.props.selectedEvent.sessionLocations || {}), Soir: e.target.value })}
                                                          placeholder="Session Soir — ex : Stade Robert Poirier, Rennes"/>
                                            <div className="text-muted small">Facultatif : à remplir quand les sessions du midi et du soir ne se tiennent pas au même endroit. Affiché sur la page de l'évènement, à l'inscription, dans le mail de confirmation et à l'accueil. Sinon le lieu ci-dessus s'applique à tout l'évènement.</div>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Nombre de places disponible : </Form.Label>
                                            <Form.Row>
                                                <NumericInput min={1}
                                                              max={100000}
                                                              value={this.props.selectedEvent.countOfAttendee}
                                                              onChange={(value) => this.props.selectedEvent.countOfAttendee = value}/>
                                                </Form.Row>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Nombre de TRCoins pour la participation : </Form.Label>
                                            <Form.Row>
                                            <NumericInput min={1}
                                                          max={100000}
                                                          value={this.props.selectedEvent.countOfCoins}
                                                          onChange={(value) => this.props.selectedEvent.countOfCoins = value}/>
                                            </Form.Row>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>URL simplifiée : </Form.Label>
                                            <Form.Control disabled type="text" onChange={(e) => this.props.selectedEvent.slug = e.target.value} defaultValue={this.props.selectedEvent.slug ? this.props.selectedEvent.slug : slugify(this.props.selectedEvent.name+"-"+this.props.selectedEvent.town)} placeholder="course-des-saucisses"/>
                                        </Form.Group>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" type="cancel" onClick={this.props.closeModal}>
                        Annuler
                    </Button>
                    <Button variant="primary" type="submit" onClick={this.handleClose}>
                        Valider
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export function sleep(time){
    return new Promise((resolve)=>setTimeout(resolve,time)
    )
}